import { Group } from '@calendly/ui/components/menu'
import { useDispatch, useSelector } from 'react-redux'

import { loadMoreData } from 'actions/home_bar/scope_dropdown'
import { encodeScopeValue } from 'components/home_bar/scope_dropdown/scope_values'
import {
  filterTermSelector,
  hasMoreUsersSelector,
  isFilteringSelector,
  usersSelector
} from 'selectors/home_bar'

import AllScope from './all_scope'
import Header from './header'
import Item from './item'
import ShowMore from './show_more'

const UsersList = ({ shouldShowAll, canManageInvitation }) => {
  const dispatch = useDispatch()
  const isFiltering = useSelector(isFilteringSelector)
  const filterTerm = useSelector(filterTermSelector)
  const users = useSelector(usersSelector)
  const hasMoreUsers = useSelector(hasMoreUsersSelector)
  const showHeader = !isFiltering || users.length > 0
  const showAllScope = shouldShowAll && !isFiltering

  return (
    <Group data-component="scope-dropdown-user-list">
      {showHeader && (
        <Header
          scope="user"
          showNewLink={canManageInvitation}
        />
      )}
      {showAllScope && (
        <AllScope scope="all_users" />
      )}
      {users.map(({ id, name, ...item }) => (
        <Item
          key={id}
          value={encodeScopeValue('user_single', id)}
          avatarLetter={item.avatar_letter}
          avatarUrl={item.avatar_url}
          filterTerm={filterTerm}
        >
          {name}
        </Item>
      ))}
      {hasMoreUsers && <ShowMore onClick={() => dispatch(loadMoreData('users'))} />}
    </Group>
  )
}

export default UsersList
